import { login, logout, getInfo } from '@/api/mobile/manager'
import { getManagerToken, setManagerToken, removeManagerToken } from '@/utils/auth'

const getDefaultState = () => {
  return {
    managerToken: getManagerToken(),
    managerName: '',
    managerUsername: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.managerToken = token
  },
  SET_NAME: (state, name) => {
    state.managerName = name
  },
  SET_USERNAME: (state, username) => {
    state.managerUsername = username
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, openid } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, openid: openid }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        const { name, username } = data
        commit('SET_NAME', name)
        commit('SET_USERNAME', username)
        setManagerToken(data.token)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      const userToken = state.token ? state.token : getManagerToken()
      getInfo(userToken).then(response => {
        const { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { name, username } = data
        commit('SET_NAME', name)
        commit('SET_USERNAME', username)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeManagerToken() // must remove token first
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  exit({ commit, state }) {
    removeManagerToken() // must remove token first
    commit('RESET_STATE')
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeManagerToken() // must remove token first
      commit('RESET_STATE')
      resolve()
    })
  },
  setLogin({ commit }, userInfo) {
    const { name, token } = userInfo
    commit('SET_TOKEN', token)
    setManagerToken(token)
    commit('SET_NAME', name)
  },
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
    setManagerToken(token)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/manager.js